import { NgModule } from '@angular/core';
import { KratosFormComponent } from '../components/kratos/form.component';
import { ReAuthenticateDialogComponent } from './reauthenticate/reauthenticate.component';

@NgModule({
  imports: [KratosFormComponent, ReAuthenticateDialogComponent],
  providers: [],
  exports: [ReAuthenticateDialogComponent],
})
export class DialogsModule {}
